import { Background, ReactFlow } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import type { ContentData } from "@/api/content";
import { toRFEdges, toRFNodes } from "@/features/content/editors/WorkflowEditor";
import { useLang } from "@/i18n/LanguageContext";

/** Read-only flowchart render of a workflow module. */
export function WorkflowView({ content }: { content: ContentData }) {
  const { t } = useLang();
  const nodes = toRFNodes(content.nodes ?? []);
  const edges = toRFEdges(content.edges ?? []);
  if (nodes.length === 0) return <p className="no-data-message">{t("Geen workflow.", "No workflow.")}</p>;

  return (
    <div className="wf-canvas wf-canvas--view">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        zoomOnScroll={false}
        panOnScroll={false}
        zoomOnDoubleClick={false}
        proOptions={{ hideAttribution: true }}
      >
        <Background />
      </ReactFlow>
    </div>
  );
}
